<template>
    <v-card class="ma-2 card-checkbox role">
        <v-card-title class="card-employee-title" :class="rolesRequired ? '' : 'required-style'">
            Roles*
        </v-card-title>
        <v-card-text class="card-checkbox">
            <v-list>
                <v-checkbox class="employee-checkbox" align-center v-if="adminRole" color="indigo" :label="adminRole.name"
                    v-model="adminRole.checked" @change="toggleAdminRole(adminRole)" :disabled="!isEditEnabled"
                ></v-checkbox>
                <v-radio-group v-model="selectedRole">
                    <v-radio class="employee-checkbox" v-for="(item, key) in rolesList" :key="key" color="indigo"
                        :label="item.name" :value="item.id" @click="onRadioButtonClick(item)" :disabled="!isEditEnabled || !isRoleEditEnabled(item)"
                    ></v-radio>
                </v-radio-group>
            </v-list>
        </v-card-text>
    </v-card>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'EmployeeRole',
    props: ['tryValidate'],
    computed: {
        adminRole() {
            const role = this.$store.state.employees.roles.find(role => role.name.toLowerCase() === 'administrator');
            return role;
        },
        rolesList() {
            return this.$store.state.employees.roles.filter(role => role.name.toLowerCase() !== 'administrator');
        },
        rolesRequired() {
            return (this.$store.state.employees.roles.some(x => x.checked) || !this.tryValidate);
        },
        selectedRole: {
            get() {
                const role = this.rolesList.find(r => r.checked);
                return role ? role.id : undefined;
            },
            set(roleId) {
                const role = this.rolesList.find(role => role.id === roleId);
                role.checked = true;
                this.toggle(role);
            }
        },
        isEditEnabled() {
            return !this.employee.archived;
        },
        ...mapGetters({
            employee: 'getEmployee',
            user: 'getUser'
        })
    },
    methods: {
        toggle(item) {
            this.$store.dispatch('toggleRole', item);
        },
        toggleAdminRole(item) {
            this.$store.dispatch('toggleAdminRole', item);
        },
        onRadioButtonClick(item) {
            if (item.checked) {
                item.checked = false;
                this.toggle(item);
            }
        },
        isRoleEditEnabled(role) {
            const isDirector = this.user && this.user.Roles && this.user.Roles.find(r => r.toLowerCase() === 'director');

            if (!isDirector) {
                const isEmplDirector = this.employee && this.employee.roles &&
                    this.employee.roles.find(r => r.name.toLowerCase() === 'director');

                if (isEmplDirector || role.name.toLowerCase() === 'director') {
                    return false;
                }
            }

            return true;
        }
    }
};
</script>
<style scoped>
.required-style {
  color: red !important;
}
</style>


// WEBPACK FOOTER //
// src/components/reusable/EmployeeRole.vue